// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { BidPackageDetailPage_TradeFragmentDoc } from '../../components/AddTradePartnerModal.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type UploadPlanBasedBidV2ModalQueryVariables = Types.Exact<{
  costCodes: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
  markets?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;


export type UploadPlanBasedBidV2ModalQuery = { __typename?: 'Query', tradePartners: Array<{ __typename?: 'TradePartner', id: string, name: string, costCodes: Array<{ __typename?: 'CostCode', id: string }> }> };


export const UploadPlanBasedBidV2ModalDocument = gql`
    query UploadPlanBasedBidV2Modal($costCodes: [ID!]!, $markets: [ID!]) {
  tradePartners(filter: {coversCostCodes: $costCodes, markets: $markets}) {
    ...BidPackageDetailPage_Trade
  }
}
    ${BidPackageDetailPage_TradeFragmentDoc}`;

/**
 * __useUploadPlanBasedBidV2ModalQuery__
 *
 * To run a query within a React component, call `useUploadPlanBasedBidV2ModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useUploadPlanBasedBidV2ModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUploadPlanBasedBidV2ModalQuery({
 *   variables: {
 *      costCodes: // value for 'costCodes'
 *      markets: // value for 'markets'
 *   },
 * });
 */
export function useUploadPlanBasedBidV2ModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UploadPlanBasedBidV2ModalQuery, UploadPlanBasedBidV2ModalQueryVariables> & ({ variables: UploadPlanBasedBidV2ModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UploadPlanBasedBidV2ModalQuery, UploadPlanBasedBidV2ModalQueryVariables>(UploadPlanBasedBidV2ModalDocument, options);
      }
export function useUploadPlanBasedBidV2ModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UploadPlanBasedBidV2ModalQuery, UploadPlanBasedBidV2ModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UploadPlanBasedBidV2ModalQuery, UploadPlanBasedBidV2ModalQueryVariables>(UploadPlanBasedBidV2ModalDocument, options);
        }
// @ts-ignore
export function useUploadPlanBasedBidV2ModalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UploadPlanBasedBidV2ModalQuery, UploadPlanBasedBidV2ModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UploadPlanBasedBidV2ModalQuery, UploadPlanBasedBidV2ModalQueryVariables>;
export function useUploadPlanBasedBidV2ModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UploadPlanBasedBidV2ModalQuery, UploadPlanBasedBidV2ModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UploadPlanBasedBidV2ModalQuery | undefined, UploadPlanBasedBidV2ModalQueryVariables>;
export function useUploadPlanBasedBidV2ModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UploadPlanBasedBidV2ModalQuery, UploadPlanBasedBidV2ModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UploadPlanBasedBidV2ModalQuery, UploadPlanBasedBidV2ModalQueryVariables>(UploadPlanBasedBidV2ModalDocument, options);
        }
export type UploadPlanBasedBidV2ModalQueryHookResult = ReturnType<typeof useUploadPlanBasedBidV2ModalQuery>;
export type UploadPlanBasedBidV2ModalLazyQueryHookResult = ReturnType<typeof useUploadPlanBasedBidV2ModalLazyQuery>;
export type UploadPlanBasedBidV2ModalSuspenseQueryHookResult = ReturnType<typeof useUploadPlanBasedBidV2ModalSuspenseQuery>;
export type UploadPlanBasedBidV2ModalQueryResult = Apollo.QueryResult<UploadPlanBasedBidV2ModalQuery, UploadPlanBasedBidV2ModalQueryVariables>;